import http from '@/libs/axios'

export function getFile(params) {
  return http({
    url: `/files/file/${params.id}`,
    method: 'get',
  })
}
export function uploadFile(data) {
  return http({
    url: '/files/file/',
    method: 'post',
    data,
  })
}
export function getUsers(params) {
  return http({
    url: '/users/users/',
    method: 'get',
    params,
  })
}

export function createUser(data) {
  return http({
    url: '/users/users/',
    method: 'post',
    data,
  })
}
export function getSingleUser(id) {
  return http({
    url: `/users/users/${id}/`,
    method: 'get',
  })
}
export function deleteUser(params) {
  return http({
    url: `/users/users/${params.id}/`,
    method: 'delete',
  })
}

export function updateUser(data) {
  return http({
    url: `/users/users/${data.id || data.get('id')}/`,
    method: 'patch',
    data,
  })
}

// roles
export function getRoles(params) {
  return http({
    url: '/users/roles/',
    method: 'get',
    params,
  })
}
export function createRole(data) {
  return http({
    url: '/users/roles/',
    method: 'post',
    data,
  })
}
export function updateRole(data) {
  return http({
    url: `/users/roles/${data.id}/`,
    method: 'patch',
    data,
  })
}
export function deleteRole(data) {
  return http({
    url: `/users/roles/${data.id}/`,
    method: 'delete',
  })
}
// groups
export function getGroups(params) {
  return http({
    url: '/users/groups/',
    method: 'get',
    params,
  })
}
